export const PLACE_ORDER_SIGNATURE =
    'placeOrder((address,address,uint32),(uint96,uint96,uint16,address,uint96),(uint32,uint16,uint16),address,address)'
export const PLACE_ORDER_SIGNATURE_BYTES32 =
    'placeOrder((address,bytes32,uint32),(uint96,uint96,uint16,address,uint96),(uint32,uint16,uint16),bytes32,address)'
export const DEPOSIT_FOR_BURN_SIGNATURE = 'depositForBurn(uint256,uint32,bytes32,address)'
export const APPROVE_SIGNATURE = 'approve(address,uint256)'
export const WRAP_GAS_SIGNATURE = 'deposit()'
export const TRANSFER_SIGNATURE = 'transfer(address,uint256)'
